import api from "./api";

const CollaboratorSkillService = {
  insert: async (args) => {
    const body = {
      collaborator: args.collaboratorId,
      skill: args.skillId,
      experience: args.experience,
    };

    const { data } = await api.post("/api/collaborator-skills/", body);
    return data;
  },

  update: async (args) => {
    const body = {
      experience: args.experience,
    };

    const { data } = await api.put(`/api/collaborator-skills/${args.id}/`, body);
    return data;
  },

  delete: async (args) => {
    const { data } = await api.delete(`/api/collaborator-skills/${args.id}/`);
    return data;
  },

  bulkUpdate: async (args) => {
    const body = {
      exp_values: args.data
    };

    const { data } = await api.put(`/api/collaborator-skills/bulk_update/`, body);
    return data;
  },
};

export default CollaboratorSkillService;
